import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
import config from '@/config';
import menu from './menu';
import dialog from './dialog';
import spinner from './spinner';
import creditFilter from './creditFilter';

Vue.use(Vuex);

const settingInfo = JSON.parse(localStorage.getItem('settingInfo')) || {};

const state = {
  userInfo: {
    groups: [],
    resource: {
      allAccount: false,
      accounts: [],
      reseller_seq: null,
    },
  },
  curAccount: {
    id: null,
    name: '(NO ACCOUNT)',
  },
  curMonth: moment().startOf('month').format('YYYY-MM'),
  preMonth: moment().startOf('month').subtract(1, 'months').format('YYYY-MM'),
  curProject: {
    id: null,
  },
  curReseller: {
    seq: 0,
    name: null,
  },
  exchangeRateList: [],
  displayCurrency: settingInfo.currency || config.currencies.default,
  corporation: null,
};

const mutations = {
  userInfo(_state, userInfo) {
    _state.userInfo = userInfo;
  },

  curAccount(_state, curAccount) {
    _state.curAccount = curAccount;
    _state.curProject.id = null;
  },

  curMonth(_state, curMonth) {
    _state.curMonth = curMonth;
  },

  preMonth(_state, preMonth) {
    _state.preMonth = preMonth;
  },

  platform(_state, platform) {
    _state.platform = platform;
  },

  curProject(_state, curProject) {
    _state.curProject = curProject;
  },

  curReseller(_state, curReseller) {
    _state.curReseller = curReseller;
  },

  exchangeRateList(_state, exchangeRateList) {
    _state.exchangeRateList = exchangeRateList;
  },

  displayCurrency(_stage, val) {
    _stage.displayCurrency = val;
  },

  corporation(_state, val) {
    _state.corporation = val;
  },
};

const actions = {
  addExchangeRates(context, exchangeRates) {
    const list = exchangeRates.reduce((arr, item) => {
      if (Array.isArray(item)) arr.push(...item);
      else arr.push(item);

      return arr;
    }, []);
    const filtering = context.state.exchangeRateList.filter(m => list.every(e => e.month !== m.month));
    filtering.push(...list);

    context.commit('exchangeRateList', filtering);
  },
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {
    menu,
    dialog,
    spinner,
    creditFilter,
  },
  strict: process.env.NODE_ENV !== 'production',
});
